
import { createSlice } from "@reduxjs/toolkit";
// Initial state for the theme and sidebar visibility
const initialState = {
  sidebarShow: true, // Sidebar visibility (true = shown, false = hidden)
  theme: 'light', // Default theme is light
};

// Redux slice for handling theme and sidebar state
export const lightDarkSlice = createSlice({
  name: "admin_theme", // Slice name
  initialState: initialState, // Initial state
  reducers: {
    // Action to change the theme (not yet implemented)
    changeTheme: (state, { payload }) => {
      return state; // Return state as is for now
    },
    
    // Action to toggle sidebar visibility
    changeSidebarShow: (state, { payload }) => {
      state.sidebarShow = payload.sidebarShow; // Update sidebar visibility
      return state; // Return updated state
    },
  },
});

// Exporting action creators for use in components
export const { changeTheme, changeSidebarShow } = lightDarkSlice.actions;

// Default export of the slice reducer
export default lightDarkSlice.reducer;
